import { useCallback } from 'react';
import { useLazyFetchLlmVisibilityPdfQuery } from '../service';
import downloadPdfReport from '../downloadPdfReport';
import { ModelFamily } from '../../llmAnalysis/types';

export default function useDownloadLlmVisibilityPdf() {
    const [fetchLlmVisibilityPdf, { isFetching }] = useLazyFetchLlmVisibilityPdfQuery();

    const downloadPdf = useCallback(
        (domain: string, modelFamily: ModelFamily) => downloadPdfReport(() => fetchLlmVisibilityPdf({ domain, model_family: modelFamily }).unwrap()),
        [fetchLlmVisibilityPdf]
    );

    return {
        downloadPdf,
        isDownloadingPdf: isFetching,
    };
}
